import React from "react";
import { getCampaignBadgesConfig } from "../../../../utils/flightCampaignConfig.js";
import { FlightCardBadge } from "./FlightCardBadge.js";
import { Stack } from "@bookingcom/bui-react";
const FlightCardCampaignBadgesList = ({ flight }) => {
    const campaignBadges = getCampaignBadgesConfig(flight.campaignDisplay?.badges);
    if (campaignBadges.length === 0) {
        return undefined;
    }
    return (React.createElement(Stack, { direction: "row", gap: 1, alignItems: "center", justifyContent: "end" }, campaignBadges.map((badge, idx) => {
        return (React.createElement(FlightCardBadge, { ...badge, key: `keyCampaignBadge-${idx}`, alternative: false, isInteractive: !!badge.ariaLabel, isFocusable: !!badge.ariaLabel, flightToken: flight.token, ariaLabel: badge.ariaLabel }));
    })));
};
export default FlightCardCampaignBadgesList;
